// eslint-disable-next-line import/no-extraneous-dependencies
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  seekTime: 0,
};

const audioSlice = createSlice({
  name: 'audio-seek',
  initialState,
  reducers: {
    setSeekTime: (state, { payload }) => {
      state.seekTime = payload;
    },
    resetAudioSeekState: () => initialState,
  },
});

export const { setSeekTime, resetAudioSeekState } = audioSlice.actions;

export const selectSeekTime = (state) => state.audioSeek.seekTime;

export default audioSlice.reducer;
